import React, { useEffect, useState } from 'react';

interface LoadingOverlayProps {
    rowHeight?: number; // Altura de cada fila
    rowGap?: number; // Espacio entre filas
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ rowHeight = 50, rowGap = 16 }) => {
    const [footerHeight, setFooterHeight] = useState(0);
    const [calculatedRows, setCalculatedRows] = useState(0);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        // Función para detectar el tamaño de pantalla
        const handleResize = () => {
            const isSmall = window.innerWidth < 768; // md es 768px en Tailwind
            setIsSmallScreen(isSmall);
        };

        // Función para calcular la altura del footer
        const calculateFooterHeight = () => {
            const footer = document.querySelector('footer');
            if (footer) {
                const footerRect = footer.getBoundingClientRect();
                setFooterHeight(footerRect.height);
            } else {
                setFooterHeight(0); // Si no hay footer, consideramos altura 0
            }
        };

        // Función para calcular las filas que caben en el espacio disponible
        const calculateRows = () => {
            const windowHeight = window.innerHeight;
            const availableHeight = isSmallScreen ? windowHeight : windowHeight - footerHeight; // Restar el footer solo en pantallas grandes
            const totalRowHeight = rowHeight + rowGap; // Sumar la altura de la fila y el espacio entre filas
            const numRows = Math.max(0, Math.floor(availableHeight / totalRowHeight)); // Aseguramos que sea al menos 0
            setCalculatedRows(numRows);
        };

        // Detectar tamaño de pantalla y calcular filas inicialmente
        handleResize();
        calculateFooterHeight();
        calculateRows();

        // Agregar listeners para cambios de tamaño de pantalla y resize del contenedor
        window.addEventListener('resize', handleResize);
        window.addEventListener('resize', calculateRows);

        // Limpiar los listeners al desmontar el componente
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('resize', calculateRows);
        };
    }, [footerHeight, rowHeight, rowGap, isSmallScreen]);

    return (
        <div
            className={`relative w-full ${
                isSmallScreen ? 'min-h-screen' : ''
            } flex flex-col justify-start items-center space-y-4`}
            style={isSmallScreen ? {} : { height: `calc(100vh - ${footerHeight}px)` }} // Usar min-h-screen para pantallas pequeñas y altura calculada para grandes
        >
            {Array.from({ length: calculatedRows }, (_, index) => (
                <div key={index} className="relative w-full h-12 bg-gray-300 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-300 via-white to-gray-300 animate-slide"></div>
                </div>
            ))}
        </div>
    );
};

export default LoadingOverlay;
